export default "__VITE_ASSET__fkH$PU4d__"